import {
  assign, endpoint, options, check, convert,
} from '../helpers';

/**
 * Brings columns of the table to the report
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const columns = (properties) => {
  const props = assign(properties);
  const model = {
    Report: props.data.report,
    Token: window.parseInt(props.data.token),
  };

  fetch(endpoint('/report-table-list-detail'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        props.success(response.Data);
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default columns;
